class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.size = 4;
        this._emptyBoard = ()=>Array.from({
                length: this.size
            }, ()=>Array(this.size).fill(0));
        this.field = this._emptyBoard();
        this.score = 0;
        this.status = "idle";
        if (Array.isArray(initialState)) this.field = initialState.map((r)=>r.slice());
        else if (initialState && Array.isArray(initialState.field)) {
            this.field = initialState.field.map((r)=>r.slice());
            this.score = Number(initialState.score || 0);
            this.status = initialState.status || "idle";
        }
        this._initialField = this.field.map((r)=>r.slice());
    }
    _cloneField(field = this.field) {
        return field.map((r)=>r.slice());
    }
    _emptyCells() {
        const res = [];
        for(let r = 0; r < this.size; r++){
            for(let c = 0; c < this.size; c++)if (this.field[r][c] === 0) res.push([
                r,
                c
            ]);
        }
        return res;
    }
    _spawnRandomTile() {
        const empties = this._emptyCells();
        if (!empties.length) return;
        const [r, c] = empties[Math.floor(Math.random() * empties.length)];
        this.field[r][c] = Math.random() < 0.9 ? 2 : 4;
    }
    _transpose(mat) {
        const t = this._emptyBoard();
        for(let r = 0; r < this.size; r++)for(let c = 0; c < this.size; c++)t[c][r] = mat[r][c];
        return t;
    }
    _rowsEqual(a, b) {
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    _has2048() {
        for(let r = 0; r < this.size; r++)for(let c = 0; c < this.size; c++){
            if (this.field[r][c] === 2048) return true;
        }
        return false;
    }
    _hasMoves() {
        if (this._emptyCells().length) return true;
        for(let r = 0; r < this.size; r++)for(let c = 0; c < this.size; c++){
            const v = this.field[r][c];
            if (r + 1 < this.size && this.field[r + 1][c] === v) return true;
            if (c + 1 < this.size && this.field[r][c + 1] === v) return true;
        }
        return false;
    }
    _compressAndMergeRowLeft(row) {
        const vals = row.filter((x)=>x !== 0);
        const res = [];
        let gained = 0;
        for(let i = 0; i < vals.length; i++)if (vals[i] === vals[i + 1]) {
            const merged = vals[i] * 2;
            res.push(merged);
            gained += merged;
            i++;
        } else res.push(vals[i]);
        while(res.length < this.size)res.push(0);
        return {
            row: res,
            gained: gained
        };
    }
    _moveLeftCore(matrix) {
        const newMat = [];
        let totalGained = 0;
        let changed = false;
        for(let r = 0; r < this.size; r++){
            const { row: newRow, gained: gained } = this._compressAndMergeRowLeft(matrix[r]);
            newMat.push(newRow);
            totalGained += gained;
            if (!this._rowsEqual(matrix[r], newRow)) changed = true;
        }
        return {
            matrix: newMat,
            changed: changed,
            totalGained: totalGained
        };
    }
    _applyMove(result) {
        if (!result.changed) return false;
        this.field = result.matrix;
        if (result.totalGained > 0) this.score += result.totalGained;
        this._spawnRandomTile();
        if (this._has2048()) this.status = "win";
        else if (!this._hasMoves()) this.status = "lose";
        return true;
    }
    getState() {
        return this._cloneField();
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        if (this.status === "running") return "playing";
        return this.status;
    }
    start() {
        this.status = "running";
        this._spawnRandomTile();
        this._spawnRandomTile();
    }
    restart() {
        this.field = this._initialField.map((r)=>r.slice());
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        if (this.status !== "running") return false;
        const res = this._moveLeftCore(this.field);
        return this._applyMove(res);
    }
    moveRight() {
        if (this.status !== "running") return false;
        const reversed = this.field.map((r)=>r.slice().reverse());
        const res = this._moveLeftCore(reversed);
        res.matrix = res.matrix.map((r)=>r.reverse());
        return this._applyMove(res);
    }
    moveUp() {
        if (this.status !== "running") return false;
        const t = this._transpose(this.field);
        const res = this._moveLeftCore(t);
        res.matrix = this._transpose(res.matrix);
        return this._applyMove(res);
    }
    moveDown() {
        if (this.status !== "running") return false;
        const t = this._transpose(this.field).map((r)=>r.reverse());
        const res = this._moveLeftCore(t);
        res.matrix = this._transpose(res.matrix.map((r)=>r.reverse()));
        return this._applyMove(res);
    }
}
var $a5fd07fa01589658$export$2e2bcd8739ae039 = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$fieldTable = document.querySelector(".game-field");
const $09e991522ca7e64e$var$rows = Array.from($09e991522ca7e64e$var$fieldTable.querySelectorAll(".field-row"));
const $09e991522ca7e64e$var$cells = $09e991522ca7e64e$var$rows.map((r)=>Array.from(r.querySelectorAll(".field-cell")));
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startMsg = document.querySelector(".message-start");
const $09e991522ca7e64e$var$winMsg = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMsg = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$btn = document.querySelector(".button");
function $09e991522ca7e64e$var$setScoreText(str) {
    $09e991522ca7e64e$var$scoreEl.textContent = str;
    $09e991522ca7e64e$var$scoreEl.setAttribute("value", str);
}
function $09e991522ca7e64e$var$renderField() {
    const state = $09e991522ca7e64e$var$game.getState();
    for(let r = 0; r < state.length; r++)for(let c = 0; c < state[r].length; c++){
        const td = $09e991522ca7e64e$var$cells[r][c];
        const v = state[r][c];
        td.className = "field-cell";
        td.textContent = v ? String(v) : "";
        if (v) td.classList.add(`field-cell--${v}`);
    }
}
function $09e991522ca7e64e$var$renderMessages() {
    const st = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$startMsg.classList.add("hidden");
    $09e991522ca7e64e$var$winMsg.classList.add("hidden");
    $09e991522ca7e64e$var$loseMsg.classList.add("hidden");
    if (st === "idle") $09e991522ca7e64e$var$startMsg.classList.remove("hidden");
    if (st === "win") $09e991522ca7e64e$var$winMsg.classList.remove("hidden");
    if (st === "lose") $09e991522ca7e64e$var$loseMsg.classList.remove("hidden");
}
function $09e991522ca7e64e$var$renderScore() {
    const st = $09e991522ca7e64e$var$game.getStatus();
    const val = $09e991522ca7e64e$var$game.getScore();
    if (st === "idle") $09e991522ca7e64e$var$setScoreText("");
    else if (st === "playing" && val === 0) $09e991522ca7e64e$var$setScoreText("");
    else $09e991522ca7e64e$var$setScoreText(String(val));
}
function $09e991522ca7e64e$var$renderAll() {
    $09e991522ca7e64e$var$renderField();
    $09e991522ca7e64e$var$renderMessages();
    $09e991522ca7e64e$var$renderScore();
}
$09e991522ca7e64e$var$btn.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$btn.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$btn.classList.remove("start");
        $09e991522ca7e64e$var$btn.classList.add("restart");
        $09e991522ca7e64e$var$btn.textContent = "Restart";
        $09e991522ca7e64e$var$renderAll();
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$btn.classList.remove("restart");
        $09e991522ca7e64e$var$btn.classList.add("start");
        $09e991522ca7e64e$var$btn.textContent = "Start";
        $09e991522ca7e64e$var$renderAll();
    }
});
document.addEventListener("keydown", (e)=>{
    const st = $09e991522ca7e64e$var$game.getStatus();
    if (![
        "playing",
        "running"
    ].includes(st)) return;
    const map = {
        ArrowLeft: ()=>$09e991522ca7e64e$var$game.moveLeft(),
        ArrowRight: ()=>$09e991522ca7e64e$var$game.moveRight(),
        ArrowUp: ()=>$09e991522ca7e64e$var$game.moveUp(),
        ArrowDown: ()=>$09e991522ca7e64e$var$game.moveDown()
    };
    const fn = map[e.key];
    if (fn) {
        fn();
        $09e991522ca7e64e$var$renderAll();
    }
});
$09e991522ca7e64e$var$renderAll();


//# sourceMappingURL=index.3bcff11c.js.map
